import { render, staticRenderFns } from "./MsPopupNotification.vue?vue&type=template&id=854efd8e&scoped=true"
import script from "./MsPopupNotification.vue?vue&type=script&lang=js"
export * from "./MsPopupNotification.vue?vue&type=script&lang=js"
import style0 from "./MsPopupNotification.vue?vue&type=style&index=0&id=854efd8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854efd8e",
  null
  
)

export default component.exports